import { useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import ArtistCard from "../../../Card/Artist";
import { Loader } from "../../../Loader";
import Tabs from "../../../Tabs";
import { mediumOptions } from "../../../../state/constants";
import { Medium, useGetArtistsQuery } from "../../../../generated/firebase";
import { firebaseClient } from "../../../../helpers/apolloClients";

const ArtistsSearchTab = () => {
  const [selectedTab, setSelectedTab] = useState<Medium | null>(null);
  const mediumTabs = [{ label: "All", value: null }, ...mediumOptions];
  const { data, loading } = useGetArtistsQuery({
    client: firebaseClient,
    variables: {
      limit: 9,
      medium: selectedTab || undefined,
    },
  });
  const artists = data?.artists.nodes || [];

  return (
    <Box>
      <Stack gap={1} direction="row" flexWrap="wrap">
        <Tabs
          onTabChange={(value) => setSelectedTab(value as Medium | null)}
          tabs={mediumTabs}
          selectedTab={selectedTab}
          style={{ overflow: "auto", justifyContent: "start" }}
        />
        <Grid container spacing={1} rowSpacing={2}>
          {loading ? (
            <Loader />
          ) : (
            artists.map((artist) => (
              <Grid item xs={12 / 3} key={artist.id}>
                <ArtistCard artist={artist} size="small" imageHeight="150px" borderRadius={12} />
              </Grid>
            ))
          )}
        </Grid>
      </Stack>
    </Box>
  );
};

export default ArtistsSearchTab;
